import React from "react";
import CardSimple from "../../../../components/basic/CardSimple";

const Scheduling = () => {
  return (
    <div id="scheduling-how-to">
      <br />
      <div>
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>How to use the Schedule Feature</h2>
            <p>
              The Schedule feature allows for easier shift scheduling and
              viewing.
            </p>
            <ul>
              <li>Go to Admin > Schedules</li>
              <img src={require("./SupportDocImages/schedule_images/schedule_image1.png")} />
              <li>Click on "+ Add New Schedule" on the top right corner</li>
              <img src={require("./SupportDocImages/schedule_images/schedule_image2.png")} />
              <li>
                Fill out the form with the date of the new shift, the start and
                end time, and the selected employee, then click confirm
              </li>
              <img src={require("./SupportDocImages/schedule_images/schedule_image3.png")} />
              <li>The new shift should now be up on the calendar</li>
            </ul>
          </div>
        </CardSimple>
      </div>

      <div id="scheduling-edit">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>How to Edit a Scheduled Shift</h2>
            <ul>
              <li>
                Click on the shift you would like to edit and change the
                required fields
              </li>
              <img src={require("./SupportDocImages/schedule_images/schedule_image4.png")} />
            </ul>
          </div>
        </CardSimple>
      </div>
    </div>
  );
};

export default Scheduling;
